module.exports = __webpack_public_path__ + "static/media/mappa-topografica.ded49cc6.png";